<template>
  <div>
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>用电申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="table">
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="srjName" label="名称" align='center' width="300"></el-table-column>
            <el-table-column prop="srjScale" label="规格" align='center'></el-table-column>
            <el-table-column prop="srjSalePrice" label="单价(RMB)" align='center' width="200"></el-table-column>
            <el-table-column prop="srjBrand" label="押金(RMB)" align='center' width="120" ></el-table-column>
            <el-table-column  label="数量" align='center'  width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.oddTotalNum"  @keyup.native="inputChange($event,scope.row)" ></el-input>
                </template>
            </el-table-column>
            <el-table-column label="小计" align='center'>
                <template slot-scope="scope">
                  {{ getFixed(scope.row)}}
                </template>
            </el-table-column>
          </el-table>
          <el-table :data="allData" style="width: 100%" border :show-header='false' :cell-style="cellStyle" >
            <el-table-column align='center' width="300"><template slot-scope="scope">{{ scope.row.text}}</template></el-table-column>
            <el-table-column  align='center'><template  slot-scope="scope">{{scope.row.price}}</template></el-table-column>
          </el-table>
          <div style="text-align:right;margin-top:20px"><el-button :style="buttonStyle" type="primary" @click="sumbit" :disabled = 'saveBtnStatue'>提交</el-button></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
    saveBtnStatue:false,  //保存铵钮状态
    tableData: [],
    getDataString:"用电申请", //获取数据，提交数据 使用
    allData:[{
      text:"费用合计：",
      price:0
    }],
    totalPrice: 0,
    buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
  }),

  components: {},
  mounted() {
    api.getservicebooklist({
      typeName:this.getDataString,
      isReservation:false
    }).then((res) => {              
        if(res.data.code == '200'){
          var _data = res.data.data.list
          this.tableData = [..._data];
          this.totalPrice = res.data.data.totalAmount
          this.getTotalPrice()
        }
    })
  },
  methods: {
    getFixed(val){
      return  parseFloat( val.oddTotalNum * (val.srjSalePrice + val.srjBrand)).toFixed( 2 ) 
    },
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      val.oddTotalNum = val.oddTotalNum.replace(/[^\d]/g,'');
      this.getTotalPrice()
    },
    cellStyle(row,column,rowIndex,columnIndex){
        return ' background: #f5f7fa;color:#000;fontWeight:bold'    
    },
    getTotalPrice(){
      let _price =0;
      var _tempArry = []
      if(this.tableData.length>0){
          for(var i=0;i<this.tableData.length;i++){
              _price += this.tableData[i].oddTotalNum * parseFloat( (this.tableData[i].srjSalePrice + this.tableData[i].srjBrand ) ).toFixed( 2 ) 
              _tempArry.push({
                "srjID": this.tableData[i].srjID,
                "num": this.tableData[i].oddTotalNum ? parseInt( this.tableData[i].oddTotalNum ) : 0
              })
          }
        }

        this.allData[0].price = parseFloat( _price ).toFixed( 2 ) 
        return _tempArry
    },
    sumbit(){
        var _paramt ={
          "typename":this.getDataString,
          "items":this.getTotalPrice()
        }
        if( this.saveBtnStatue ){
          return false
        }
        this.saveBtnStatue = true
        api.saveservicebook(_paramt).then((res) => {              
            if(res.data.code == '200'){
                  this.$notify({
                    title: '保存成功',
                    type: 'success',
                     duration: 2000
                  })
            }else{
                  this.$notify({
                    title: '保存失败',
                    msg: res.data.msg,
                    type: 'warning',
                    duration: 2000
                  })
            }
            this.saveBtnStatue = false
        })
    }

  }
}
</script>
<style lang="less">
.table{
  margin:20px 0
}
.itembox{
  font-size:14px;
  line-height: 2.2;
  .el-input{
    display: inline-block;
    width:120px;
  }
  .el-card__body{
    padding:10px
  }
  .total{
    background: #f5f7fa;
    padding: 10px;
    margin-top: 10px;
  }
  .supitem{
    border-bottom:1px solid #eee;
    padding-bottom:10px;
  }
}
</style>

